import { ValidationErrorData } from './common';

export type ShowsFrequencyEditorState = Record<string, ShowsFrequencyValue>;

export enum ShowsFrequencyPeriodPreset {
    Period = 'custom-period',
    CampaignTime = 'campaign-time'
}

export interface ShowsFrequencyInitData extends ShowsFrequencyValue {
    editorId: string;
}

export interface ShowsFrequencyValue {
    isActive: boolean;
    showsLimit: string;
    periodPreset: ShowsFrequencyPeriodPreset;
    customPeriod: string;
    showsLimitErrors?: ValidationErrorData[];
    customPeriodErrors?: ValidationErrorData[];
}
